var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.article.images.length)?_c('img',{attrs:{"src":_vm.article.images[0].hosting_url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }